import React from "react";

// Import Styles
import "../styles/Home.css";

function Home() {
  return (
    <div>
      <div className="Home">
        <h1>Crea tu estilo con nosotros</h1>
        <p>Lucir tu mejor corte nunca pasa de moda.</p>

        <a
          className="date__button"
          id="Setmore_button_iframe"
          href="https://booking.setmore.com/scheduleappointment/e72bd35c-0692-4df3-997f-58149adda25b"
        >
          Reserva Tu Cita Ahora
        </a>
      </div>
    </div>
  );
}

export default Home;
